// The Journal menu entry's count, kept out of the page's own chunk: the sidebar renders it for
// everyone who can see the menu, whether or not they ever open the Journal.
import { useApi, useAuth } from "@keel/core";

/**
 * Entries waiting for this person's approval (ERP-180). Re-read every half minute, as is the list
 * on the page, so an open Journal picks up a new one without a reload.
 */
export function usePendingJournalBadge() {
  const { can } = useAuth();
  const drafts =
    useApi<{ status: string; canApprove: boolean }[]>(
      can("accounting.journal.approve") ? "/accounting/journal-drafts" : null,
      { refetchInterval: 30_000 },
    ).data ?? [];
  const n = drafts.filter((d) => d.status === "pending" && d.canApprove).length;
  return n ? { n, tone: "warn" as const } : null;
}
